import React, { useState } from 'react';
import {
  Box, TextField, Button, Stack, MenuItem, Select, FormControl,
  InputLabel, CircularProgress,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';
import salesAPI from '../../api/sales';

const NOTE_TYPES = [
  { value: 'call',   label: '📞 Call' },
  { value: 'email',  label: '📧 Email' },
  { value: 'sms',    label: '💬 SMS' },
  { value: 'meeting',label: '🤝 Meeting' },
  { value: 'note',   label: '📝 Note' },
];

const OUTCOMES = [
  { value: 'no_answer',         label: 'No Answer' },
  { value: 'left_voicemail',    label: 'Left Voicemail' },
  { value: 'connected',         label: 'Connected' },
  { value: 'not_interested',    label: 'Not Interested' },
  { value: 'callback_requested',label: 'Callback Requested' },
  { value: 'interested',        label: 'Interested!' },
  { value: 'other',             label: 'Other' },
];

export default function QuickNoteBar({ leadId, onLeadUpdated }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const [type, setType] = useState('call');
  const [outcome, setOutcome] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!content.trim()) { toast.warning('Note cannot be empty'); return; }
    setSaving(true);
    try {
      const res = await salesAPI.addNote(leadId, { content: content.trim(), type, outcome: outcome || undefined });
      onLeadUpdated(res.data.data);
      setContent('');
      setOutcome('');
      setOpen(false);
      toast.success('Note saved');
    } catch { toast.error('Failed to save note'); }
    finally { setSaving(false); }
  };

  if (!open) {
    return (
      <Button size="small" startIcon={<AddIcon />} variant="outlined" onClick={() => setOpen(true)} fullWidth>
        Add Note / Log Call
      </Button>
    );
  }

  return (
    <Box sx={{ bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1.5 }}>
      <Stack direction="row" gap={1} mb={1}>
        <FormControl size="small" sx={{ minWidth: 110 }}>
          <InputLabel>Type</InputLabel>
          <Select value={type} label="Type" onChange={(e) => setType(e.target.value)}>
            {NOTE_TYPES.map((t) => <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>)}
          </Select>
        </FormControl>
        {(type === 'call') && (
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel>Outcome</InputLabel>
            <Select value={outcome} label="Outcome" onChange={(e) => setOutcome(e.target.value)}>
              <MenuItem value="">— Select —</MenuItem>
              {OUTCOMES.map((o) => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
            </Select>
          </FormControl>
        )}
      </Stack>
      <TextField
        multiline
        minRows={2}
        fullWidth
        size="small"
        placeholder="Notes from this interaction…"
        value={content}
        onChange={(e) => setContent(e.target.value)}
        sx={{ mb: 1 }}
      />
      <Stack direction="row" gap={1} justifyContent="flex-end">
        <Button size="small" onClick={() => setOpen(false)}>Cancel</Button>
        <Button size="small" variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? <CircularProgress size={16} /> : 'Save Note'}
        </Button>
      </Stack>
    </Box>
  );
}
